/**
 * Regimes tributários (catálogo único). O Cadastros guarda o regime da empresa com vigência (`cadastros_parceiro_regimes`);
 * o Pipeline guarda o regime pretendido da negociação (lote crm5, E10). Os rótulos ficam no i18n do Cadastros
 * (`cadastros:valores.regime.<valor>`).
 */
// Review rlb-1 (SPEC-B4, lista de 30/10 B item 3.1 d, "na ordem certa"): do menor ao maior porte (MEI, Simples Nacional, Lucro
// presumido, Lucro real), em toda lista que mostra o regime. Só a ordem de exibição muda; o valor gravado é o mesmo.
export const REGIMES_TRIBUTARIOS = ['mei', 'simples', 'presumido', 'real'] as const;
export type RegimeTributario = (typeof REGIMES_TRIBUTARIOS)[number];
export const ehRegimeTributario = (v: unknown): v is RegimeTributario => typeof v === 'string' && (REGIMES_TRIBUTARIOS as readonly string[]).includes(v);
